import React from 'react';
import { Col, Row } from "react-bootstrap";
import { RumListProps } from '../../types';

import { RumListItem } from './RumListItem';

function RumList(props: RumListProps): JSX.Element {
    const { rums, onRumSelection } = props;

    const onRumClick = (rumIndex: number): void => {
        onRumSelection(rumIndex);
        console.log(`selected rum at index, ${rumIndex}`);
    };

    return (
        <>
            <Row>
                <Col>
                    {rums.length} items found
                </Col>
            </Row>
            {rums.map(
                    (rum, i) => <RumListItem key={i} onRumSelection={() => onRumClick(i)} rum={rum} />
            )}
        </>
    );
}

export { RumList };
